import React from 'react'
import './index.scss'
import { ZodFormattedError } from 'zod'
import WriterCardBody from '@Components/ViewWork/WriterCard/WriterCardBody'
import { WriterModel } from '@Entities/work/writer-model'

interface WriterCardProps {
    writers: WriterModel[]
    errors?: ZodFormattedError<WriterModel[]>
}

const WriterCard = ({ writers, errors }: WriterCardProps) => (
    <>
        {writers.length ? (
            <div className="writer-card-v2">
                <div className="card-header card-row">
                    <div>Writer Name</div>
                    <div>Writer IPI</div>
                    <div>Writer Role</div>
                </div>
                <div className="card-body">
                    {writers.map((writer, idx) => (
                        <WriterCardBody writer={writer} key={idx} error={errors ? errors[idx] : undefined} />
                    ))}
                </div>
            </div>
        ) : (
            <div className="missing-records">No writers listed</div>
        )}
    </>
)

export default WriterCard
